import React, { Fragment, useContext } from 'react';
import { AuthContext } from '../../../context/authContext/AuthContext';
import { logout } from '../../../context/authContext/AuthActions';
import { LogoutRounded } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
const SidebarFooter = ({ history }) => {
  const { dispatch } = useContext(AuthContext);

  function onLogout() {
    dispatch(logout());
    window.location.replace(`${process.env.PUBLIC_URL}/login`);
  }
  return (
    <Fragment>
      <div className="text-center" style={{padding:'25px 10px', position:'relative'}}>
        <Tooltip title="Logout">
        <LogoutRounded
          onClick={onLogout}
          className="f-14 btn bg-white"
          style={{
            padding: '3px',
            marginLeft: '40px',
            width: '2rem',
            height: '2rem',
          }}
          
        />
        </Tooltip>
        {/* <button onClick={onLogout} className="f-14 btn bg-white" style={{padding:'3px'}}>LOGOUT</button> */}
      </div>
    </Fragment>
  );
};

export default SidebarFooter;
